/**
 * Точка входа клиента: монтирует игру или, по параметру `?debug`, стенд графики.
 *
 * Стенд живёт в том же входе, что и игра. Отдельная страница требовала бы своей
 * точки сборки и своей копии разметки, а нужна ровно одна: посмотреть слои вживую.
 * Загружается лениво: в игру его код не попадает.
 */

import { StrictMode, Suspense, lazy } from 'react'
import { createRoot, type Root } from 'react-dom/client'
import { App } from './src/app.js'

const AppDebug = lazy(() => import('./src/app.debug.js').then((m) => ({ default: m.AppDebug })))

// Шов сквозных проверок: только по `?e2e`, отдельным чанком — игрокам его код не уходит.
if (new URLSearchParams(location.search).has('e2e')) void import('./src/app.e2e.js')

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root element')
const standalone = new URLSearchParams(location.search).has('debug')
const hot = import.meta.hot as (ImportMeta['hot'] & { data: { root?: Root } }) | undefined
const appRoot = hot?.data.root ?? createRoot(root)
if (hot) hot.data.root = appRoot

appRoot.render(
  <StrictMode>
    {standalone ? (
      <Suspense fallback={null}>
        <AppDebug />
      </Suspense>
    ) : (
      <App />
    )}
  </StrictMode>,
)
